import React from "react";
// import flexible from '../../utils/flexible';
import "./index.less";
import contentImg from "./img/content.png";

class TmsAbout extends React.Component {
  constructor(props) {
    super(props);
    this.state = {};
  }
  render() {
    // document.title = '关于绿色慧联';
    return (
      <div className="page_type_h5">
        <div id="tmsAbout">
          <section className="no-one">
            <h3></h3>
            <p>
              定位于绿色运力和智慧车联网平台提供商，注册资本5亿元，总部位于浙江杭州。
            </p>
            <p>
              绿色慧联以场景定制为核心，为客户提供慧联租车、慧联车服、慧联智控等新能源物流车全生命周期运营管理服务，秉承慧联人的激情、梦想、拼搏、创新精神，致力于打造绿色运力共享平台，建立绿色联盟，为推动绿色物流和智慧物流发展而努力。
            </p>
          </section>
          <section className="no-two">
            <h3></h3>
          </section>
          <section className="no-three">
            {/* <img src="https://image.tf56.com/dfs/group1/M00/58/11/CiFBCVsjTNCAX5glAAVk5klbgm4770.png" alt="" /> */}
            <img src={contentImg} alt="" />
          </section>
          <section className="no-four">
            <h3></h3>
            <p>
              "慧运力共享平台"是绿色慧联在能源革命、产业变革和技术进步三重叠加，货物流通模式正发生根本性变化的大背景下，在运力进化层面根据自身技术优势及发展需求，结合城市配送领域的B2B自动驾驶示范运营项目打造的智能运力服务共享平台。
            </p>
          </section>
          <section className="no-six">
            <h3></h3>
            <p>如遇问题，请联系我们。联系电话：</p>
            <p>
              <a href="tel:4008262266">400-826-2266</a> ;{" "}
              <a href="tel:057182899926">0571-82899926</a>
            </p>
          </section>
        </div>
      </div>
    );
  }
}

export default TmsAbout;



// WEBPACK FOOTER //
// ./src/staticPage/tmsAbout/index.js